<template>
  <FormKit
    type="qselect"
    trackBy="id"
    labelBy="name"
    :options="settlements"
    v-model="model"
    :placeholder="context.placeholder ?? 'Муниципалитет'"
    :classes="{ outer: '!mb-0' }"
  />
</template>

<script setup>
import { computed } from 'vue'

import { useGlobalStore } from '@/store/global.js'

const emits = defineEmits(['passed', 'update:model-value'])
const global = useGlobalStore()

const settlements = global.getSettlements

const props = defineProps({
  context: {
    type: Object,
  },
  passed: {
    type: Boolean,
  },
  modelValue: {
    type: [String, Number, Object],
  },
})

const model = computed({
  get: () => {
    return props.modelValue
  },
  set: (val) => {
    emits('update:model-value', val)
  },
})
</script>
